import moment from 'moment-timezone';
export const TYPE_DATE_TIME = 'DD-MM-YY HH:mm:ss';

export const getFirstOfDay = (date: Date): number => new Date(date).setHours(0, 0, 0);
export const getEndOfDay = (date: Date): number => new Date(date).setHours(23, 59, 59);

export const getFirstDayOfMonth = (date: Date): number =>
  getFirstOfDay(new Date(date.getFullYear(), date.getMonth(), 1));
export const getLastDayOfMonth = (date: Date): number =>
  getEndOfDay(new Date(date.getFullYear(), date.getMonth() + 1, 0));

export const getFirstDayOfWeek = (date: Date): number =>
  getFirstOfDay(new Date(date.setDate(date.getDate() - date.getDay())));
export const getLastDayOfWeek = (date: Date): number =>
  getEndOfDay(new Date(date.setDate(date.getDate() - date.getDay() + 6)));

export const getFirstDayOfYear = (date: Date): number =>
  getFirstOfDay(new Date(new Date(date).getFullYear(), 0, 1));
export const getLastDayOfYear = (date: Date): number =>
  getEndOfDay(new Date(date.getFullYear(), 11, 31));

export const addTimeJS = (date: Date, step = 1, time: 'year' | 'month' | 'week' | 'day'): Date => {
  switch (time) {
    case 'year':
      return new Date(date.setFullYear(date.getFullYear() + step));

    case 'month':
      return new Date(new Date(date).getFullYear(), date.getMonth() + step, 1);

    case 'week':
      return new Date(date.setDate(date.getDate() + 7 * step));

    case 'day':
      return new Date(date.setDate(date.getDate() + step));

    default:
      return new Date();
  }
};

export const getTodaysDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const subTimeJS = (date: Date, step = 1, time: 'year' | 'month' | 'week' | 'day'): Date => {
  switch (time) {
    case 'year':
      return new Date(date.setFullYear(date.getFullYear() - step));

    case 'month':
      return new Date(new Date(date).getFullYear(), date.getMonth() - step, 1);

    case 'week':
      return new Date(date.setDate(date.getDate() - 7 * step));

    case 'day':
      return new Date(date.setDate(date.getDate() - step));

    default:
      return new Date();
  }
};

type KeyHideDate = 'year' | 'month' | 'date';
export const renderDate = (dateInput: Date, key?: KeyHideDate): string => {
  const date = `0${new Date(dateInput).getDate()}`.slice(-2);
  const month = `0${new Date(dateInput).getMonth() + 1}`.slice(-2);
  const year = `${new Date(dateInput).getFullYear()}`;
  switch (key) {
    case 'year':
      return `${date}-${month}`;

    default:
      return `${date}-${month}-${year}`;
  }
};

export const renderTime = (date: Date): string => {
  return `${`0${new Date(date).getHours()}`.slice(-2)}:${`0${new Date(date).getMinutes()}`.slice(
    -2,
  )} ${new Date(date).getHours() >= 12 ? ' PM' : ' AM'}`;
};

export const renderDateTime = (dateTime: any) => {
  // Convert dateTime from Moment Object to String "2021-05-28 08:45:59"
  return moment(dateTime).format(TYPE_DATE_TIME);
};

export const convertTimestampToDate = (timestamp: number): string => {
  const date = new Date(timestamp); // Create a Date object from the timestamp
  const formattedDate = renderDate(date); // Format the date part
  const formattedTime = renderTime(date); // Format the time part
  return `${formattedDate} ${formattedTime}`; // Combine date and time
};

export const mapDateHeaderByKeys = (date: string) => {
  switch (date) {
    case 'today':
      return 'Today';
    case 'last_7d':
      return 'Last 7d';
    case 'last_30d':
      return 'Last 30d';
    case 'this_year':
      return 'This Year';
    case 'all_time':
      return 'All Time';
    case 'yesterday':
      return 'Yesterday';
    default:
      return '';
  }
};

export const getCountdown = (diff: number) => {
  const days = String(Math.floor(diff / (24 * 60 * 60 * 1000)));
  const hours = String(Math.floor((diff % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000)));
  const minutes = String(Math.floor((diff % (60 * 60 * 1000)) / (60 * 1000)));
  const seconds = String(Math.floor((diff % (60 * 1000)) / 1000));
  return { days, hours, minutes, seconds };
};

export const isInStockTimeRange = () => {
  const now = moment().tz('America/New_York');
  
  const weekday = now.day();
  if (weekday === 0 || weekday === 6) {
    return false;
  }
  
  const today = now.clone().startOf('day');
  const marketOpen = today.clone().hour(9).minute(31).second(0);
  const marketClose = today.clone().hour(15).minute(59).second(0);
  
  const isInRange = now.isSameOrAfter(marketOpen) && now.isBefore(marketClose);
  
  return isInRange;
};
